module.exports = __webpack_public_path__ + "static/media/landing.513f1193.png";